// extracted by mini-css-extract-plugin
export default {"dynamic-split-layout-slot":"kJmtYy","dynamicSplitLayoutSlot":"kJmtYy"};